import { transformIntegerNumber } from "@king-ict/eupisi-ui/utils";
import { TFunction } from "i18next";
import * as yup from "yup";

export interface InstitutionCriterionValidationSchemaProps {
  t: TFunction;
}

export const InstitutionCriterionValidationSchema = ({
  t,
}: InstitutionCriterionValidationSchemaProps) => {
  const requiredMsg = t("validations.required");
  const pointsMsg = t("criterion.pointsValidation");

  return yup.object().shape({
    criterionId: yup.number().nullable().required(requiredMsg),
    points: yup.number().when("isDirectEnrollment", {
      is: (isDirectEnrollment: boolean) => isDirectEnrollment,
      then: yup.number().nullable(),
      otherwise: yup
        .number()
        .transform(transformIntegerNumber)
        .min(0, pointsMsg)
        .max(1000, pointsMsg)
        .required(pointsMsg),
    }),
  });
};
